import { FileService } from '../../providers'

const FileModule = {
  namespaced: true,
  actions: {
    async uploadPrivateDocument (_context, formData) {
      const result = await FileService.uploadPrivateDocument(formData)
      return result
    }
  }
}

export default FileModule
